export default __webpack_public_path__ + "static/background-65a939d4094877e4e77f881bdbbac9d7.svg";